// Übersetzungen [Suomi, English] der Lernhilfen im Spielmodus und von „Lerne aus Fehlern“.
export const COACH: Record<string, [string, string]> = {
  'Lernhilfen': ['Oppimisapu', 'Learning aids'],
  'Hinweis': ['Vihje', 'Hint'],
  'Zug zurück': ['Siirto takaisin', 'Take back'],
  'Fehler sofort zeigen': ['Näytä virheet heti', 'Show mistakes at once'],
  'Der Coach prüft deinen Zug …': ['Valmentaja tarkistaa siirtosi …', 'The coach is checking your move …'],
  'Besser war {m}.': ['Parempi oli {m}.', '{m} was better.'],
  'Nochmal versuchen': ['Yritä uudelleen', 'Try again'],
  'Weiterspielen': ['Jatka peliä', 'Play on'],
  'Eröffnung': ['Avaus', 'Opening'],
  'Theorie': ['Teoriaa', 'Theory'],
  'außerhalb der Theorie': ['teorian ulkopuolella', 'out of theory'],
  'Die Partien der Bibliothek werden ausgewertet …': ['Kirjaston pelejä käydään läpi …', 'Going through the library games …'],
  'In der Bibliothek von hier gespielt ({n} Partien)': ['Kirjastossa pelattu tästä ({n} peliä)', 'Played from here in the library ({n} games)'],
  'Weiß {w} % · Remis {d} % · Schwarz {b} %': ['Valkea {w} % · Tasapeli {d} % · Musta {b} %', 'White {w} % · Draw {d} % · Black {b} %'],
  '1 Fehler in dieser Partie': ['1 virhe tässä pelissä', '1 mistake in this game'],
  '{n} Fehler in dieser Partie': ['{n} virhettä tässä pelissä', '{n} mistakes in this game'],
  'Lerne aus Fehlern': ['Opi virheistä', 'Learn from mistakes'],
  'Zurück zur Partie': ['Takaisin peliin', 'Back to the game'],
  'Fertig: {a} von {b} selbst gefunden.': ['Valmis: löysit itse {a}/{b}.', 'Done: you found {a} of {b} yourself.'],
  'Noch einmal': ['Vielä kerran', 'Once more'],
  'Finde einen besseren Zug.': ['Etsi parempi siirto.', 'Find a better move.'],
  'Nicht ganz. Noch ein Versuch?': ['Ei aivan. Vielä yksi yritys?', 'Not quite. One more try?'],
  'Lösung zeigen': ['Näytä ratkaisu', 'Show solution'],
  'Gut gefunden. Stockfish empfiehlt {m}.': ['Hyvin löydetty. Stockfish suosittelee {m}.', 'Well found. Stockfish recommends {m}.'],
  'Richtig: {m}.': ['Oikein: {m}.', 'Correct: {m}.'],
  'Weiter': ['Seuraava', 'Next'],
  'Lösung: {m}': ['Ratkaisu: {m}', 'Solution: {m}'],
  'Aufgegeben. {n} gewinnt.': ['Luovutit. {n} voitti.', 'Resigned. {n} wins.'],
  'Der Server ist gerade nicht erreichbar.': ['Palvelin ei ole juuri nyt tavoitettavissa.', 'The server cannot be reached right now.'],
  'Gegner erneut fragen': ['Kysy vastustajalta uudelleen', 'Ask the opponent again'],
};
